import { render, staticRenderFns } from "./SelectOrganization.vue?vue&type=template&id=71318630&scoped=true"
import script from "./SelectOrganization.vue?vue&type=script&lang=ts"
export * from "./SelectOrganization.vue?vue&type=script&lang=ts"
import style0 from "./SelectOrganization.vue?vue&type=style&index=0&id=71318630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71318630",
  null
  
)

export default component.exports